<template>
	<ConfirmationDialog class="discard-changes-prompt">
		<template #header>
			<h1 class="discard-changes-prompt__heading">
				{{ translate( "title" ) }}
			</h1>
		</template>
		<template #description>
			<main class="discard-changes-prompt__main">
				<slot name="body">
					{{ translate( "description" ) }}
				</slot>
			</main>
		</template>
		<template #actions>
			<footer class="discard-changes-prompt__footer">
				<TeamingButton
					size="SMALL"
					type="PRIMARY"
					:destructive="true"
					@click="$emit( `confirm` )"
				>
					{{ translate( "confirmButton" ) }}
				</TeamingButton>
				<!-- FEATUREFLAG -->
				<TeamingButton
					v-if="$config().enableSaveDraftKeyResult"
					size="SMALL"
					type="TERTIARY"
					@click="$emit( `save` )"
				>
					{{ translate( "saveButton" ) }}
				</TeamingButton>
				<TeamingButton
					size="SMALL"
					type="QUATERNARY"
					@click="$emit( `dismiss` )"
				>
					{{ translate( "dismissButton" ) }}
				</TeamingButton>
			</footer>
		</template>
	</ConfirmationDialog>
</template>

<script>
import { ConfirmationDialog, TeamingButton } from "@teaming/common-ui";
export default {
	name: "DiscardChangesPrompt",
	emits: [ "confirm", "save", "dismiss", ],
	components: {
		ConfirmationDialog,
		TeamingButton,
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.DiscardChangesPrompt.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>
$discard-changes-prompt-title-color: $color1-700;

.discard-changes-prompt__heading {
	@include font-and-line-for(1);
	font-weight: 600;
	color: $discard-changes-prompt-title-color;
}

.discard-changes-prompt__footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
}
</style>
